export default "__VITE_ASSET__B8f9xezq__"